const Footer = () => {
  return (
    <footer className="mt-auto py-6 bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-800">
      <div className="container mx-auto px-4 text-center text-sm text-gray-500 dark:text-gray-400">
        <p>© {new Date().getFullYear()} Alex/Designr.co. All rights reserved.</p>
        <p className="mt-1">Made with ☕ and 🧠</p>
      </div>
    </footer>
  );
};

export default Footer;
